'use strict';

var _defineProperty = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/defineProperty.js")["default"];
var _regeneratorRuntime = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/regeneratorRuntime.js")["default"];
var _asyncToGenerator = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/asyncToGenerator.js")["default"];
var _createForOfIteratorHelper = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js")["default"];
var _toConsumableArray = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/toConsumableArray.js")["default"];
var _slicedToArray = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/slicedToArray.js")["default"];
var _objectSpread = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js")["default"];
var _classCallCheck = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/classCallCheck.js")["default"];
var _createClass = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/createClass.js")["default"];
var _callSuper = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/callSuper.js")["default"];
var _inherits = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/inherits.js")["default"];
Object.defineProperty(exports, '__esModule', {
  value: true
});
var d = require('react');
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var d__namespace = /*#__PURE__*/_interopNamespace(d);
var x = /*#__PURE__*/function (_d__namespace$Compone) {
  function x(r) {
    var _this;
    _classCallCheck(this, x);
    _this = _callSuper(this, x, [r]), _this.state = {
      hasError: !1
    };
    return _this;
  }
  _inherits(x, _d__namespace$Compone);
  return _createClass(x, [{
    key: "componentDidCatch",
    value: function componentDidCatch(r, o) {
      console.error("GIF Picker React failed to render:", r, o);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.hasError ? null : this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: !0
      };
    }
  }]);
}(d__namespace.Component);
var he = d__namespace["default"].createContext(null),
  s = he;
var ye = d__namespace.createContext(null),
  p = ye;
function a(e) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    r = _ref.insertAt;
  if (!e || typeof document > "u") return;
  var o = document.head || document.getElementsByTagName("head")[0],
    t = document.createElement("style");
  t.type = "text/css", r === "top" && o.firstChild ? o.insertBefore(t, o.firstChild) : o.appendChild(t), t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
a(".GifPickerReact .gpr-body{display:flex;flex:1;min-height:0}\n");
var xe = d__namespace.createContext(null),
  l = xe;
a(".GifPickerReact .gpr-category-placeholder{border-radius:var(--gpr-category-border-radius);position:relative}\n");
a(".GifPickerReact .gpr-placeholder{background-color:var(--gpr-placeholder-color);transition:opacity .2s ease-in-out}\n");
function be(e) {
  return d__namespace["default"].createElement("div", _objectSpread(_objectSpread({}, e), {}, {
    className: "gpr-placeholder ".concat(e.className || ""),
    style: _objectSpread({
      width: e.width,
      height: e.height
    }, e.style)
  }));
}
var v = be;
function Pe() {
  var e = d.useContext(l);
  return d__namespace["default"].createElement(v, {
    className: "gpr-category-placeholder",
    height: e.categoryHeight,
    width: "100%"
  });
}
var j = Pe;
a(".GifPickerReact .gpr-category-list{display:grid;grid-gap:var(--gpr-category-list-padding);flex:1;grid-auto-rows:min-content;overflow-y:scroll;padding:var(--gpr-body-padding)}\n");
a(".GifPickerReact .gpr-category{border-radius:var(--gpr-category-border-radius);cursor:pointer;position:relative;transition:box-shadow .15s ease-in-out}.GifPickerReact .gpr-category img{background-color:#d3d3d3;border-radius:var(--gpr-category-border-radius);height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.GifPickerReact .gpr-category-overlay{align-items:center;background-color:rgba(0,0,0,var(--gpr-category-background-opacity));border-radius:var(--gpr-category-border-radius);display:flex;height:100%;justify-content:center;left:0;overflow:hidden;position:absolute;top:0;transition:background-color .15s ease-in-out;width:100%}.GifPickerReact .gpr-category-overlay .gpr-category-name{color:var(--gpr-category-font-color);font-size:var(--gpr-category-font-size);font-weight:var(--gpr-category-font-weight);text-shadow:0 1px 1px rgba(0,0,0,var(--gpr-category-shadow-opacity))}.GifPickerReact .gpr-category:hover{box-shadow:0 0 0 2px var(--gpr-category-border-color-hover)}.GifPickerReact .gpr-category:hover .gpr-category-overlay{background-color:rgba(0,0,0,var(--gpr-category-shadow-opacity-hover))}\n");
function we(_ref2) {
  var e = _ref2.image,
    r = _ref2.text,
    o = _ref2.onClick;
  var t = d.useContext(l);
  return d__namespace["default"].createElement("button", {
    type: "button",
    className: "gpr-btn gpr-category",
    style: {
      height: t.categoryHeight
    },
    "data-testid": "gpr-category",
    onClick: o
  }, d__namespace["default"].createElement("img", {
    src: e,
    loading: "lazy"
  }), d__namespace["default"].createElement("div", {
    className: "gpr-category-overlay"
  }, d__namespace["default"].createElement("div", {
    className: "gpr-category-name"
  }, r)));
}
var C = we;
function Ge(_ref3) {
  var e = _ref3.image,
    r = _ref3.name;
  var _d$useContext = d.useContext(s),
    _d$useContext2 = _slicedToArray(_d$useContext, 2),
    o = _d$useContext2[0],
    t = _d$useContext2[1];
  function n() {
    var i = Object.assign({}, o);
    i.searchTerm = r, t(i);
  }
  return d__namespace["default"].createElement(C, {
    image: e,
    text: r,
    onClick: n
  });
}
var K = Ge;
a(".GifPickerReact .gpr-icn-trending{background-color:transparent;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Cpath fill='%23fff' d='M6.3 37 4 34.7l15-15 8 8.05L41.9 11l2.1 2.05-17 19.2-8-7.95Z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:20px;height:20px;width:20px}.GifPickerReact .gpr-category .gpr-text-trending-category{align-items:center;display:flex;gap:4px}\n");
function Ie(_ref4) {
  var e = _ref4.image;
  var _d$useContext3 = d.useContext(s),
    _d$useContext4 = _slicedToArray(_d$useContext3, 2),
    r = _d$useContext4[0],
    o = _d$useContext4[1];
  function t() {
    var n = Object.assign({}, r);
    n.showTrending = !0, o(n);
  }
  return d__namespace["default"].createElement(C, {
    image: e,
    onClick: t,
    text: d__namespace["default"].createElement("div", {
      className: "gpr-text-trending-category"
    }, d__namespace["default"].createElement("div", {
      className: "gpr-icn-trending"
    }), d__namespace["default"].createElement("span", null, "Trending GIFs"))
  });
}
var _ = Ie;
function Le(_ref5) {
  var e = _ref5.categories,
    r = _ref5.trending,
    o = _ref5.columnsCount;
  var n;
  function t() {
    if (!e) return;
    var g = (e.length + 1) % o;
    return g == 0 ? e : e == null ? void 0 : e.slice(0, -g);
  }
  return d__namespace["default"].createElement("div", {
    className: "gpr-category-list",
    style: {
      gridTemplateColumns: "repeat(".concat(o, ", 1fr)")
    }
  }, e && r ? d__namespace["default"].createElement(d__namespace["default"].Fragment, null, d__namespace["default"].createElement(_, {
    image: r.url
  }), (n = t()) == null ? void 0 : n.map(function (i, c) {
    return d__namespace["default"].createElement(K, {
      key: c,
      image: i.image,
      name: i.name
    });
  })) : d__namespace["default"].createElement(d__namespace["default"].Fragment, null, _toConsumableArray(Array(10 * o)).map(function (i, c) {
    return d__namespace["default"].createElement(j, {
      key: c
    });
  })));
}
var z = Le;
a(".GifPickerReact .gpr-gif-list{display:flex;flex:1;flex-direction:row;gap:var(--gpr-category-list-padding);overflow-y:scroll;padding:var(--gpr-body-padding)}.GifPickerReact .gpr-gif-list-column{display:grid;flex:1;grid-gap:var(--gpr-category-list-padding);grid-auto-rows:min-content;grid-template-columns:1fr;grid-template-rows:auto 1fr}.GifPickerReact .gpr-gif-list-no-result{align-items:center;display:flex;flex:1;justify-content:center;padding-bottom:30%}\n");
a(".GifPickerReact .gpr-result-placeholder{border-radius:var(--gpr-category-border-radius)}\n");
function Fe(_ref6) {
  var e = _ref6.height,
    r = _ref6.showDelay;
  var _d$useState = d.useState(!1),
    _d$useState2 = _slicedToArray(_d$useState, 2),
    o = _d$useState2[0],
    t = _d$useState2[1];
  return d.useEffect(function () {
    if (o) return;
    function n() {
      t(!0);
    }
    var i = setTimeout(n, r);
    return function () {
      return clearTimeout(i);
    };
  }, []), d__namespace["default"].createElement(v, {
    className: "gpr-result-placeholder",
    height: e,
    width: "100%",
    style: {
      opacity: o ? 1 : 0
    }
  });
}
var O = Fe;
var X = [[120, 100, 130, 175, 154, 110], [150, 115, 135, 154, 145, 170], [140, 125, 120, 150, 100, 125], [130, 145, 175, 120, 135, 100]];
function Be(_ref7) {
  var e = _ref7.columnsCount,
    _ref7$showDelay = _ref7.showDelay,
    r = _ref7$showDelay === void 0 ? 70 : _ref7$showDelay;
  return d__namespace["default"].createElement("div", {
    className: "gpr-gif-list"
  }, _toConsumableArray(Array(e)).map(function (o, t) {
    return d__namespace["default"].createElement("div", {
      className: "gpr-gif-list-column",
      key: t
    }, X[t % X.length].map(function (n, i) {
      return d__namespace["default"].createElement(O, {
        key: i,
        height: n,
        showDelay: (i + 1) * r * e + r * t
      });
    }));
  }));
}
var J = Be;
a(".GifPickerReact .gpr-result-image{border-radius:var(--gpr-category-border-radius);cursor:pointer;transition:box-shadow .15s ease-in-out}.GifPickerReact .gpr-result-image img{background-color:var(--gpr-placeholder-color);border-radius:var(--gpr-category-border-radius);height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.GifPickerReact .gpr-result-image:hover{box-shadow:0 0 0 2px var(--gpr-category-border-color-hover)}\n");
function He(_ref8) {
  var e = _ref8.image,
    r = _ref8.searchTerm;
  var o = d.useContext(l),
    t = d.useContext(p);
  function n() {
    var i = o.onGifClick;
    i && i(e), t.registerShare(e, r);
  }
  return d__namespace["default"].createElement("button", {
    type: "button",
    className: "gpr-btn gpr-result-image",
    onClick: n
  }, d__namespace["default"].createElement("img", {
    src: e.preview.url,
    height: e.preview.height,
    width: e.preview.width,
    loading: "lazy"
  }));
}
var q = He;
function je(_ref9) {
  var e = _ref9.isLoading,
    r = _ref9.result,
    o = _ref9.searchTerm,
    t = _ref9.columnsCount;
  var n = d.useMemo(function () {
      return Ke(r, t);
    }, [r, t]),
    i = !r || r.images.length <= 0;
  return e ? d__namespace["default"].createElement(J, {
    columnsCount: t
  }) : i ? d__namespace["default"].createElement("div", {
    className: "gpr-gif-list-no-result"
  }, d__namespace["default"].createElement("span", null, "No GIFs found!")) : d__namespace["default"].createElement("div", {
    className: "gpr-gif-list"
  }, n.map(function (c, g) {
    return d__namespace["default"].createElement("div", {
      className: "gpr-gif-list-column",
      key: g
    }, c.map(function (u) {
      return d__namespace["default"].createElement(q, {
        key: u.id,
        image: u,
        searchTerm: o
      });
    }));
  }));
}
function Ke(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!e) return [];
  var o = new Array(r).fill(null).map(function () {
      return [];
    }),
    t = new Array(r).fill(0);
  var _iterator = _createForOfIteratorHelper(e.images),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var n = _step.value;
      var i = n.preview.height / n.preview.width,
        c = t.indexOf(Math.min.apply(Math, _toConsumableArray(t)));
      o[c].push(n), t[c] += i;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return o;
}
var P = je;
function Xe(_ref10) {
  var e = _ref10.searchTerm,
    r = _ref10.columnsCount;
  var _d$useState3 = d.useState(null),
    _d$useState4 = _slicedToArray(_d$useState3, 2),
    o = _d$useState4[0],
    t = _d$useState4[1],
    _d$useState5 = d.useState(!0),
    _d$useState6 = _slicedToArray(_d$useState5, 2),
    n = _d$useState6[0],
    i = _d$useState6[1],
    c = d.useContext(p);
  return d.useEffect(function () {
    i(!0);
    function g() {
      return _g.apply(this, arguments);
    }
    function _g() {
      _g = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var m;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return c.search(e);
            case 2:
              m = _context.sent;
              t(m), i(!1);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _g.apply(this, arguments);
    }
    var u = setTimeout(function () {
      return g();
    }, 800);
    return function () {
      return clearTimeout(u);
    };
  }, [e]), d__namespace["default"].createElement(P, {
    isLoading: n,
    columnsCount: r,
    result: o,
    searchTerm: e
  });
}
var Y = Xe;
function qe(_ref11) {
  var e = _ref11.columnsCount;
  var _d$useState7 = d.useState(null),
    _d$useState8 = _slicedToArray(_d$useState7, 2),
    r = _d$useState8[0],
    o = _d$useState8[1],
    _d$useState9 = d.useState(!0),
    _d$useState10 = _slicedToArray(_d$useState9, 2),
    t = _d$useState10[0],
    n = _d$useState10[1],
    i = d.useContext(p);
  return d.useEffect(function () {
    n(!0), _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var c;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return i.trending();
          case 2:
            c = _context2.sent;
            o(c), n(!1);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }, []), d__namespace["default"].createElement(P, {
    columnsCount: e,
    isLoading: t,
    result: r
  });
}
var Q = qe;
var Ye = 170;
function Ze(_ref13) {
  var e = _ref13.width;
  var _d$useState11 = d.useState(void 0),
    _d$useState12 = _slicedToArray(_d$useState11, 2),
    r = _d$useState12[0],
    o = _d$useState12[1],
    _d$useState13 = d.useState(void 0),
    _d$useState14 = _slicedToArray(_d$useState13, 2),
    t = _d$useState14[0],
    n = _d$useState14[1],
    _d$useContext5 = d.useContext(s),
    _d$useContext6 = _slicedToArray(_d$useContext5, 1),
    i = _d$useContext6[0],
    _d$useState15 = d.useState(1),
    _d$useState16 = _slicedToArray(_d$useState15, 2),
    c = _d$useState16[0],
    g = _d$useState16[1],
    u = d.useContext(p),
    m = d.useRef(null);
  return d.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var E, y;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return u.categories();
          case 2:
            E = _context3.sent;
            o(E);
            _context3.next = 6;
            return u.trending(1);
          case 6:
            y = _context3.sent;
            n(y.images[0]);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }, []), d.useEffect(function () {
    var E = m.current ? m.current.offsetWidth : 0,
      y = Math.floor(E / Ye);
    y < 1 && (y = 1), g(y);
  }, [m.current, e]), d__namespace["default"].createElement("div", {
    className: "gpr-body",
    ref: m
  }, i.showTrending ? d__namespace["default"].createElement(Q, {
    columnsCount: c
  }) : i.searchTerm ? d__namespace["default"].createElement(Y, {
    columnsCount: c,
    searchTerm: i.searchTerm
  }) : d__namespace["default"].createElement(z, {
    columnsCount: c,
    categories: r,
    trending: t
  }));
}
var re = Ze;
a(".GifPickerReact .gpr-header{border-bottom:1px solid var(--gpr-picker-border-color);min-height:0;padding:var(--gpr-header-padding)}\n");
function Qe(e) {
  return d__namespace.createElement("button", _objectSpread(_objectSpread({
    type: "button"
  }, e), {}, {
    className: "gpr-btn " + e.className
  }), e.children);
}
var w = Qe;
a(".GifPickerReact button.gpr-btn-clear-search{align-items:center;border-radius:50%;display:flex;height:20px;justify-content:end;padding:0;position:absolute;right:var(--gpr-search-bar-inner-padding);top:50%;transform:translateY(-50%);width:20px}.GifPickerReact .gpr-icn-clear-search{background-color:transparent;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' width='20' height='80'%3E%3Cpath fill='%23868686' d='M6.98 13.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 8c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.4a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.2-.21.54 0 .74'/%3E%3Cpath fill='%23868686' d='M10.15 18.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8m0-14.94c3.83 0 6.94 3.11 6.94 6.94s-3.11 6.94-6.94 6.94-6.94-3.11-6.94-6.94 3.12-6.94 6.94-6.94'/%3E%3Cpath fill='%233371B7' d='M6.98 33.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 28c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75'/%3E%3Cpath fill='%233371B7' d='M10.15 38.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8m0-14.94c3.83 0 6.94 3.11 6.94 6.94s-3.11 6.94-6.94 6.94-6.94-3.11-6.94-6.94 3.12-6.94 6.94-6.94'/%3E%3Cpath fill='%23C0C0BF' d='M6.98 53.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 48c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75'/%3E%3Cpath fill='%23C0C0BF' d='M10.15 58.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8m0-14.94c3.83 0 6.94 3.11 6.94 6.94s-3.11 6.94-6.94 6.94-6.94-3.11-6.94-6.94 3.12-6.94 6.94-6.94'/%3E%3Cpath fill='%236AA9DD' d='M6.98 73.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 68c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75'/%3E%3Cpath fill='%236AA9DD' d='M10.15 78.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8m0-14.94c3.83 0 6.94 3.11 6.94 6.94s-3.11 6.94-6.94 6.94-6.94-3.11-6.94-6.94 3.12-6.94 6.94-6.94'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:20px;height:20px;width:20px}.GifPickerReact .gpr-search-container button.gpr-btn-clear-search:focus .gpr-icn-clear-search,.GifPickerReact button.gpr-btn-clear-search:hover .gpr-icn-clear-search{background-position-y:-20px}.GifPickerReact button.gpr-btn-clear-search:focus,.GifPickerReact button.gpr-btn-clear-search:hover{background:var(--gpr-hover-bg-color)}.GifPickerReact.gpr-dark-theme button.gpr-btn-clear-search .gpr-icn-clear-search{background-position-y:-40px}.GifPickerReact.gpr-dark-theme button.gpr-btn-clear-search:hover .gpr-icn-clear-search{background-position-y:-60px}\n");
function Ve(_ref15) {
  var e = _ref15.onClick;
  return d__namespace["default"].createElement(w, {
    className: "gpr-btn-clear-search",
    onClick: e
  }, d__namespace["default"].createElement("div", {
    className: "gpr-icn-clear-search"
  }));
}
var ie = Ve;
a(".GifPickerReact .gpr-search-container{display:block;flex:1;min-width:0;position:relative}.GifPickerReact .gpr-search-container input.gpr-search{background-color:var(--gpr-search-input-bg-color);border:1px solid var(--gpr-search-input-bg-color);border-radius:var(--gpr-search-input-border-radius);color:var(--gpr-search-input-text-color);height:var(--gpr-search-input-height);outline:none;padding:var(--gpr-search-input-padding);transition:all .2s ease-in-out;width:100%}.GifPickerReact .gpr-search-container .gpr-icn-search{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' width='20' height='40'%3E%3Cpath fill='%23868686' fill-rule='evenodd' d='M12 8.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 6.73 12 8.81m-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92s2.2-4.92 4.92-4.92 4.92 2.2 4.92 4.92c0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0z' clip-rule='evenodd'/%3E%3Cpath fill='%23C0C0BF' fill-rule='evenodd' d='M12 28.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 26.73 12 28.81m-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92s2.2-4.92 4.92-4.92 4.92 2.2 4.92 4.92c0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0z' clip-rule='evenodd'/%3E%3C/svg%3E\");background-position:0 0;background-repeat:no-repeat;background-size:20px;content:\"\";height:20px;left:var(--gpr-search-bar-inner-padding);position:absolute;top:50%;transform:translateY(-50%);width:20px}.GifPickerReact.gpr-dark-theme .gpr-search-container .gpr-icn-search{background-position-y:-20px}.GifPickerReact .gpr-search-container input.gpr-search::-moz-placeholder{color:var(--gpr-search-input-placeholder-color)}.GifPickerReact .gpr-search-container input.gpr-search::placeholder{color:var(--gpr-search-input-placeholder-color)}.GifPickerReact .gpr-search-container input.gpr-search:focus{background-color:var(--gpr-search-input-bg-color-active);border:1px solid var(--gpr-search-border-color-active)}\n");
function er() {
  var _d$useContext7 = d.useContext(s),
    _d$useContext8 = _slicedToArray(_d$useContext7, 2),
    e = _d$useContext8[0],
    r = _d$useContext8[1],
    o = d.useContext(l);
  function t(i) {
    var c = Object.assign({}, e);
    c.searchTerm = i.target.value, r(c);
  }
  function n() {
    var i = Object.assign({}, e);
    i.searchTerm = "", r(i);
  }
  return d__namespace["default"].createElement("div", {
    className: "gpr-search-container"
  }, d__namespace["default"].createElement("input", {
    autoFocus: o.autoFocusSearch,
    "aria-label": "Search Tenor",
    placeholder: "Search Tenor",
    className: "gpr-search",
    "data-testid": "gpr-search-input",
    type: "text",
    dir: "auto",
    maxLength: 500,
    value: e.searchTerm,
    onChange: t
  }), d__namespace["default"].createElement("div", {
    className: "gpr-icn-search"
  }), e.searchTerm.length > 0 && d__namespace["default"].createElement(ie, {
    onClick: n
  }));
}
var ae = er;
a(".GifPickerReact .gpr-title-container{display:block;flex:1;min-width:0;position:relative}.GifPickerReact .gpr-title-container .gpr-title{align-items:center;background-color:var(--gpr-search-input-bg-color);border-radius:var(--gpr-search-input-border-radius);color:var(--gpr-search-input-text-color);display:flex;height:var(--gpr-search-input-height);padding:var(--gpr-horizontal-padding);width:100%}\n");
function tr(_ref16) {
  var e = _ref16.children;
  var _d$useContext9 = d.useContext(s),
    _d$useContext10 = _slicedToArray(_d$useContext9, 2),
    r = _d$useContext10[0],
    o = _d$useContext10[1];
  function t() {
    var n = Object.assign({}, r);
    n.showTrending = !1, o(n);
  }
  return d__namespace["default"].createElement("div", {
    className: "gpr-title-container"
  }, d__namespace["default"].createElement("div", {
    className: "gpr-title"
  }, e), d__namespace["default"].createElement(w, {
    className: "gpr-btn-clear-search",
    onClick: t
  }, d__namespace["default"].createElement("div", {
    className: "gpr-icn-clear-search"
  })));
}
var ce = tr;
function ir() {
  var _d$useContext11 = d.useContext(s),
    _d$useContext12 = _slicedToArray(_d$useContext11, 1),
    e = _d$useContext12[0];
  return d__namespace["default"].createElement("div", {
    className: "gpr-header"
  }, e.showTrending ? d__namespace["default"].createElement(ce, null, "Trending GIFs") : d__namespace["default"].createElement(ae, null));
}
var se = ir;
var M = function (n) {
    return n.HIGH = "high", n.MEDIUM = "medium", n.LOW = "low", n.OFF = "off", n;
  }(M || {}),
  G = function (t) {
    return t.LIGHT = "light", t.DARK = "dark", t.AUTO = "auto", t;
  }(G || {});
function cr(_ref17) {
  var e = _ref17.children;
  var r = d.useContext(l),
    o = {
      height: r.height,
      width: r.width
    };
  return d__namespace["default"].createElement("aside", {
    className: "GifPickerReact gpr-main ".concat(r.theme === "dark" ? " gpr-dark-theme" : ""),
    style: o
  }, e);
}
var le = cr;
a(".GifPickerReact{color-scheme:light;--gpr-highlight-color:#007aeb;--gpr-hover-bg-color:#f1f8ff;--gpr-focus-bg-color:#e0f0ff;--gpr-text-color:#858585;--gpr-search-input-bg-color:#f6f6f6;--gpr-picker-border-color:#e7e7e7;--gpr-bg-color:#fff;--gpr-horizontal-padding:10px;--gpr-picker-border-radius:8px;--gpr-header-padding:15px var(--gpr-horizontal-padding);--gpr-search-input-bg-color-active:var(--gpr-search-input-bg-color);--gpr-search-input-padding:0 32px;--gpr-search-input-border-radius:8px;--gpr-search-input-height:40px;--gpr-search-input-text-color:var(--gpr-text-color);--gpr-search-input-placeholder-color:var(--gpr-text-color);--gpr-search-bar-inner-padding:var(--gpr-horizontal-padding);--gpr-search-border-color-active:var(--gpr-highlight-color);--gpr-body-padding:var(--gpr-header-padding) 0px;--gpr-category-list-padding:var(--gpr-horizontal-padding);--gpr-category-border-radius:4px;--gpr-category-background-opacity:40%;--gpr-category-font-color:var(--gpr-picker-border-color);--gpr-category-font-size:16px;--gpr-category-font-weight:600;--gpr-category-shadow-opacity:60%;--gpr-category-shadow-opacity-hover:65%;--gpr-category-border-color-hover:var(--gpr-highlight-color);--gpr-placeholder-color:#d3d3d3}.GifPickerReact.gpr-dark-theme{color-scheme:dark;--gpr-dark:#000;--gpr-hover-bg-color:#363636f6;--gpr-focus-bg-color:#474747;--gpr-text-color:silver;--gpr-search-input-bg-color:#3b3b3b;--gpr-picker-border-color:#2b2b2b;--gpr-bg-color:#222;--gpr-category-font-color:#e7e7e7;--gpr-search-input-bg-color-active:var(--gpr-dark);--gpr-placeholder-color:var(--gpr-search-input-bg-color)}.GifPickerReact *{box-sizing:border-box}.GifPickerReact.gpr-main{background-color:var(--gpr-bg-color);border-color:var(--gpr-picker-border-color);border-radius:var(--gpr-picker-border-radius);border-style:solid;border-width:1px;color:var(--gpr-text-color);display:flex;flex-direction:column;position:relative}.GifPickerReact button.gpr-btn{background:none;border:0;cursor:pointer;outline:none;padding:0}\n");
function lr(e) {
  var r = {
      searchTerm: e,
      showTrending: !1
    },
    _d$useState17 = d.useState(r),
    _d$useState18 = _slicedToArray(_d$useState17, 2),
    o = _d$useState18[0],
    t = _d$useState18[1];
  return [o, t];
}
var pe = lr;
function pr(e) {
  var _e$onGifClick, _e$autoFocusSearch, _e$clientKey, _e$country, _e$locale, _e$contentFilter, _e$height, _e$width, _e$categoryHeight, _e$initialSearchTerm;
  if (!e.tenorApiKey) throw new Error("tenorApiKey is a required prop that is missing");
  return {
    tenorApiKey: e.tenorApiKey,
    onGifClick: (_e$onGifClick = e.onGifClick) !== null && _e$onGifClick !== void 0 ? _e$onGifClick : void 0,
    autoFocusSearch: (_e$autoFocusSearch = e.autoFocusSearch) !== null && _e$autoFocusSearch !== void 0 ? _e$autoFocusSearch : !0,
    clientKey: (_e$clientKey = e.clientKey) !== null && _e$clientKey !== void 0 ? _e$clientKey : "gif-picker-react",
    country: (_e$country = e.country) !== null && _e$country !== void 0 ? _e$country : "US",
    locale: (_e$locale = e.locale) !== null && _e$locale !== void 0 ? _e$locale : "en_US",
    contentFilter: (_e$contentFilter = e.contentFilter) !== null && _e$contentFilter !== void 0 ? _e$contentFilter : "off",
    height: N((_e$height = e.height) !== null && _e$height !== void 0 ? _e$height : 450),
    width: N((_e$width = e.width) !== null && _e$width !== void 0 ? _e$width : 350),
    categoryHeight: N((_e$categoryHeight = e.categoryHeight) !== null && _e$categoryHeight !== void 0 ? _e$categoryHeight : 100),
    theme: gr(e.theme),
    initialSearchTerm: (_e$initialSearchTerm = e.initialSearchTerm) !== null && _e$initialSearchTerm !== void 0 ? _e$initialSearchTerm : ""
  };
}
function N(e) {
  if (typeof e == "number") return "".concat(e, "px");
  if (typeof e == "string") return e;
  throw new TypeError("Invalid dimension provided");
}
function gr(e) {
  return e === "auto" ? dr() ? "dark" : "light" : e !== null && e !== void 0 ? e : "light";
}
function dr() {
  return typeof window > "u" ? !1 : !!window.matchMedia("(prefers-color-scheme: dark)").matches;
}
var ge = pr;
var ur = "gif,tinygif",
  mr = "https://tenor.googleapis.com/v2/",
  F = /*#__PURE__*/function () {
    function F(r, o, t, n, i) {
      _classCallCheck(this, F);
      _defineProperty(this, "apiKey", void 0);
      _defineProperty(this, "clientKey", void 0);
      _defineProperty(this, "country", void 0);
      _defineProperty(this, "locale", void 0);
      _defineProperty(this, "contentFilter", void 0);
      this.apiKey = r, this.clientKey = o, this.country = t, this.locale = n, this.contentFilter = i;
    }
    return _createClass(F, [{
      key: "callApi",
      value: function () {
        var _callApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(r, o) {
          var t, n;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                t = new URLSearchParams(_objectSpread({
                  key: this.apiKey,
                  client_key: this.clientKey,
                  contentfilter: this.contentFilter,
                  media_filter: ur,
                  locale: this.locale,
                  country: this.country
                }, o)), n = mr + r + "?" + t;
                return _context4.abrupt("return", fetch(n).then(function (i) {
                  return i.ok || (console.error(i), console.error("[gif-picker-react] Failed to fetch data from Tenor API")), i;
                }).then(function (i) {
                  return i.json();
                })["catch"](function (i) {
                  console.error(i), console.error("[gif-picker-react] Failed to fetch data from Tenor API");
                }));
              case 2:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function callApi(_x, _x2) {
          return _callApi.apply(this, arguments);
        }
        return callApi;
      }()
    }, {
      key: "praseResult",
      value: function praseResult(r) {
        var o = r.media_formats.tinygif,
          t = r.media_formats.gif;
        return {
          id: r.id,
          tenorUrl: r.itemurl,
          shortTenorUrl: r.url,
          description: r.content_description,
          createdAt: new Date(r.created * 1e3),
          tags: r.tags,
          url: t.url,
          width: t.dims[0],
          height: t.dims[1],
          preview: {
            url: o.url,
            width: o.dims[0],
            height: o.dims[1]
          }
        };
      }
    }, {
      key: "categories",
      value: function () {
        var _categories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.callApi("categories", {
                  type: "featured"
                }).then(function (r) {
                  return r.tags.map(function (t) {
                    return {
                      name: t.searchterm,
                      image: t.image
                    };
                  });
                }));
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function categories() {
          return _categories.apply(this, arguments);
        }
        return categories;
      }()
    }, {
      key: "search",
      value: function () {
        var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(r) {
          var _this2 = this;
          var o,
            _args6 = arguments;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                o = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 50;
                return _context6.abrupt("return", this.callApi("search", {
                  q: r,
                  ar_range: "all",
                  limit: o
                }).then(function (t) {
                  var i = t.results.map(_this2.praseResult);
                  return {
                    next: t.next,
                    images: i
                  };
                }));
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function search(_x3) {
          return _search.apply(this, arguments);
        }
        return search;
      }()
    }, {
      key: "trending",
      value: function () {
        var _trending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var _this3 = this;
          var r,
            _args7 = arguments;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                r = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 50;
                return _context7.abrupt("return", this.callApi("featured", {
                  ar_range: "all",
                  limit: r
                }).then(function (o) {
                  var n = o.results.map(_this3.praseResult);
                  return {
                    next: o.next,
                    images: n
                  };
                }));
              case 2:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function trending() {
          return _trending.apply(this, arguments);
        }
        return trending;
      }()
    }, {
      key: "registerShare",
      value: function () {
        var _registerShare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(r, o) {
          var t;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                t = {
                  id: r.id
                };
                o && (t.q = o);
                _context8.next = 4;
                return this.callApi("registershare", t);
              case 4:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function registerShare(_x4, _x5) {
          return _registerShare.apply(this, arguments);
        }
        return registerShare;
      }()
    }]);
  }(),
  de = F;
function hr(e) {
  var r = ge(e),
    o = pe(r.initialSearchTerm),
    t = d.useMemo(function () {
      return new de(r.tenorApiKey, r.clientKey, r.country, r.locale, r.contentFilter);
    }, []);
  return d__namespace["default"].createElement(l.Provider, {
    value: r
  }, d__namespace["default"].createElement(s.Provider, {
    value: o
  }, d__namespace["default"].createElement(p.Provider, {
    value: t
  }, d__namespace["default"].createElement(le, null, d__namespace["default"].createElement(se, null), d__namespace["default"].createElement(re, {
    width: e.width
  })))));
}
var ue = hr;
function yr(e) {
  return d__namespace["default"].createElement(x, null, d__namespace["default"].createElement(ue, _objectSpread({}, e)));
}
var Xo = yr;
exports.ContentFilter = M;
exports.Theme = G;
exports["default"] = Xo;